module.exports = __webpack_public_path__ + "img/poly-5.72291f77.png";